(() => {
  "use strict";

  if (window.GuruSvgIcons?.version === 1) return;

  const namespace = "http://www.w3.org/2000/svg";
  const paths = Object.freeze({
    "arrow-right": ["M4.5 12h15M14 6.5l5.5 5.5-5.5 5.5"],
    "arrow-left": ["M19.5 12h-15M10 6.5 4.5 12l5.5 5.5"],
    "arrow-up-right": ["M6.5 17.5 17.5 6.5M8 6.5h9.5V16"],
    "chevron-left": ["m15 5-7 7 7 7"],
    "chevron-right": ["m9 5 7 7-7 7"],
    plus: ["M12 5v14M5 12h14"],
    minus: ["M5 12h14"],
    close: ["m6 6 12 12M18 6 6 18"],
    star: ["m12 2.7 2.82 5.72 6.31.92-4.57 4.45 1.08 6.29L12 17.11l-5.64 2.97 1.08-6.29-4.57-4.45 6.31-.92L12 2.7Z"],
  });

  const create = (name, className = "") => {
    const svg = document.createElementNS(namespace, "svg");
    const normalizedName = Object.hasOwn(paths, name) ? name : "";
    svg.setAttribute("class", `guru-svg-icon guru-svg-icon--${normalizedName}${className ? ` ${className}` : ""}`);
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.setAttribute("aria-hidden", "true");
    svg.setAttribute("focusable", "false");
    paths[normalizedName]?.forEach((pathData) => {
      const path = document.createElementNS(namespace, "path");
      path.setAttribute("d", pathData);
      if (normalizedName === "star") path.classList.add("guru-svg-icon__fill");
      svg.append(path);
    });
    return svg;
  };

  window.GuruSvgIcons = Object.freeze({ create, version: 1 });
})();
